import { Provider } from '@angular/core';
import { SsoOauthService } from './oauth';
import { SsoOktaService } from './okta';
import { SsoSamlService } from './saml';
import { SsoIdpHttpService } from './sso-idp-http.service';
import { SsoIdpsResolverService } from './sso-idps-resolver.service';

export const getSsoIdpProviders = (): Provider[] => [
  SsoSamlService,
  SsoOauthService,
  SsoOktaService,
  SsoIdpsResolverService,
  SsoIdpHttpService,
];
